import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

import { Button, Grid } from '@mui/material';
import Box from '@mui/material/Box';

import { FontAwesomeSvgIcon, Tooltip } from 'components/shared';

import DrawerFooter from '../../../../Drawer/DrawerFooter';
import { FormComponentProps } from '../../../TableCRUDLayout';
import useFindIndexFromFieldsArray from '../../../hooks/useFindIndexFromFieldsArray';
import { useFieldArrayContext } from '../hooks/useFieldArrayContext';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import React from 'react';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const withFieldArrayDrawer =
  (Component: React.FC<any>, fieldArrayId: string) =>
  (props: FormComponentProps & any) => {
    const { t } = useTranslation('common');
    const { getValues, trigger } = useFormContext();
    const { fields, update } = useFieldArrayContext();
    const fieldIndex = useFindIndexFromFieldsArray(
      props.rowId ?? getLastAddedFieldId(fields),
      fields
    );

    const fieldId = `${fieldArrayId}[${fieldIndex}]`;

    return (
      <>
        <Grid
          container
          sx={{
            width: '400px',
            padding: 2.5,
            display: 'flex',
            maxHeight: 'calc(100vh - 158px)',
            overflowY: 'auto',
            marginBottom: '72px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              flexDirection: 'column',
              position: 'relative'
            }}
          >
            <Component {...props} />
          </Box>
        </Grid>
        <DrawerFooter>
          <Tooltip title={props.rowId ? t('save') : t('addToList')}>
            <Button
              variant="contained"
              color="dark"
              onClick={async () => {
                // onPreSubmit && (await onPreSubmit(fieldId, fields, context));
                trigger(fieldId).then((isValid) => {
                  if (isValid) {
                    update(fieldIndex, {
                      ...getValues(fieldId),
                      isCommitted: true
                    });
                    props.handleClose();
                  }
                });
              }}
            >
              <FontAwesomeSvgIcon icon={faCheck} />
            </Button>
          </Tooltip>
        </DrawerFooter>
      </>
    );
  };

export default withFieldArrayDrawer;
